import { type Enum } from '@webapp/utils'

export const PaymentSourceTransactionStatuses = {
  PENDING: 'PENDING',
  SETTLED: 'SETTLED',
  CANCELLED: 'CANCELLED',
}

export type PaymentSourceTransactionStatus = Enum<
  typeof PaymentSourceTransactionStatuses
>
